import React, { useState,useEffect  } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import axios from 'axios';

const AddDeliveryPoint = ({ show, onClose, selectedBranch, onSuccess  }) => {
    const [deliveryPoint, setDeliveryPoint] = useState('');
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [areas, setAreas] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [existingDeliveryPoints, setExistingDeliveryPoints] = useState([]);

    useEffect(() => {
    if (show && selectedBranch?.branch_name) { // Ensure selectedBranch is available and has branch_name
        axios
            .get(`${baseURL}/managearea`, {
                params: { branch_id: selectedBranch.sno  }, // Send the branch_name for filtering areas
            })
            .then((response) => {
                console.log('Areas API response:', response.data);
                const areaList = response.data.data.data || [];
                const filteredByBranch = areaList.filter(item => item.branch_name === selectedBranch.sno && item.status === 0);

                const formatted = filteredByBranch
                .filter(item => item.assigned_delivery_point !== 1)
                .map(item => ({
                    sno: item.sno,
                    name: item.area_name,
                }));

                setAreas(formatted);// Assuming response.data.data contains the filtered areas
            })
            .catch((error) => {
                console.error('Error fetching areas:', error);
                alert('Failed to load areas. Please try again.');
            });
        }
    }, [show, baseURL, selectedBranch]);
    

    useEffect(() => {
        if (show && selectedBranch?.sno) {
            axios.get(`${baseURL}/managedeliverypoint`, {
            params: { branch_name: selectedBranch.sno }
            })
            .then(response => {
            console.log('Existing Delivery Points response:', response.data);
            // Grab the array from response.data.data.data
            const pointsArray = Array.isArray(response.data?.data?.data) ? response.data.data.data : [];
            setExistingDeliveryPoints(pointsArray);
            })
            .catch(error => {
            console.error('Failed to fetch existing delivery points:', error);
            setExistingDeliveryPoints([]);
            });
        } else {
            setExistingDeliveryPoints([]);
        }
    }, [show, selectedBranch, baseURL]);

    const handleAreaChange = (areaId) => {
    if (selectedAreas.includes(areaId)) {
        setSelectedAreas(selectedAreas.filter(id => id !== areaId)); // remove
    } else {
        setSelectedAreas([...selectedAreas, areaId]); // add
    }
    };

    const [data_name, setData] = useState([]);
    useEffect(() => {
        const params = {
            branch_id: selectedBranch.sno
        };
        // axios.get(`${baseURL}/managelead`, { params: params })
        axios.get(`${baseURL}/dropdown/deliverypoint`, {params: params})
          .then(response => {
            setData(response.data.data.map(mode => mode.delivery_point?.toLowerCase?.() || ''));
          })
          .catch(error => {
            console.log('There was an error fetching the data!', error);
          });
    }, [])

    const handleSubmit = async () => {
        const newErrors = {};
        if (!deliveryPoint.trim()) {
            newErrors.deliveryPoint = 'This Field is required.';
        } else if (data_name.includes(deliveryPoint.trim().toLowerCase())){
            newErrors.deliveryPoint = 'Delivery Point Already Exists.';
        }
        if (selectedAreas.length === 0) {
            newErrors.areas = 'Atleast Choose One';
        }

        const isDuplicate = existingDeliveryPoints.some(
            dp => dp.delivery_point.toLowerCase() === deliveryPoint.trim().toLowerCase()
        );
        if (isDuplicate) {
            newErrors.deliveryPoint = 'Delivery Point Already exists for this Branch.';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        try {
            setLoading(true);
            const multipleaarea = JSON.stringify(selectedAreas);
            const selectedAreaObjects = areas.filter(area => selectedAreas.includes(area.sno));
            // console.log(multipleaarea);
            const response = await axios.post(`${baseURL}/managedeliverypoint`, {
                branch_name: selectedBranch?.sno,
                delivery_point: deliveryPoint.trim(),
                area_name: selectedAreaObjects,
            });

            const createdDeliveryPoint = response.data.data;

            toast.success("Delivery Point created successfully!");
             if (onSuccess) onSuccess(createdDeliveryPoint);
            // window.location.reload();
            setDeliveryPoint('');
            setSelectedAreas([]);
            setErrors({});
            setLoading(false);
            onClose();
        } catch (error) {
            console.error('Error creating delivery point:', error);
            alert('Failed to create delivery point. Please try again.');
        }
    };

    const handleCancel = () => {
        setDeliveryPoint('');
        setSelectedAreas([]);
        setErrors({});
        onClose();
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Delivery Point</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-3">
                            <div className="row">
                                <label class="col-12 text-black fs-7">  {selectedBranch?.manage_branch_type === 1 ? "Franchise" : "Branch"}</label>
                                <label class="col-12 text-red font-w500 fs-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedBranch?.branch_name || "N/A"}</label>
                            </div>
                        </div>
                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Delivery Point<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Delivery Point" maxLength={50} value={deliveryPoint} 
                            onChange={(e) => {
                                if (e.target.value.length <= 50) {
                                setDeliveryPoint(e.target.value);
                                }
                            }}/>
                            {errors.deliveryPoint && (
                                <small className="text-danger">{errors.deliveryPoint}</small>
                            )}
                        </div>
                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Select Area<span className="required">*</span></label>
                            <div className='row mb-2'>
                            {areas.length > 0 ? (
                                areas.map((area) => (                                
                                <div className="col-lg-6" key={area.sno}>
                                    <div className='form-check-inline mt-3'>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value={area.sno}
                                            onChange={() => handleAreaChange(area.sno)}
                                        />
                                        <label className="fs-7 text-black mb-0 font-w500">{area.name}</label>
                                    </div>
                                </div>
                                ))
                                ) : (
                                    <p className="text-muted">No areas available.</p>
                                )}
                            </div>
                            {errors.areas && (
                                <small className="text-danger">{errors.areas}</small>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="submit" className={`btn btn-sm btn-primary ${loading ? 'disabled' : ''} `} onClick={handleSubmit}>{loading ? 'Loading...' : 'Create Delivery Point'} <i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddDeliveryPoint;
